export default __webpack_public_path__ + "static/media/tijolos.036ccdb4.svg";